if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();

      this.renderSlider()
      console.log('CollectionList component initialized', this);
    }

    renderSlider() {
      new Swiper(this, {
        spaceBetween: 26,
        centerMode: true,
        loop: false,
        centerMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1.3
          },
          640: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 2.3
          },
          991: {
            slidesPerView: 3
          }
        }
      });
    }
  }
  customElements.define('collection-list', CollectionList);
}